import WaitingExecutionCardIcon from './component'

export default WaitingExecutionCardIcon
